import ActiveService from '@/service.active';
import {PL_TRANSLATION} from "./pl.const";
import {EN_TRANSLATION} from "./en.const";
import {CZ_TRANSLATION} from "./cz.const";

const translates = {
	"PL": PL_TRANSLATION,
	"EN": EN_TRANSLATION,
	"CZ": CZ_TRANSLATION,
};

class TranslatesService extends ActiveService {
	/**
	 *
	 * @param $q
	 * @param $http
	 */
	constructor($injector) {
		'ngInject';
		super($injector);
		this.url = '/translates';
		this.cacheKey = 'translates';
	}

	/**
	 *
	 * @param callback
	 * @returns {*}
	 * @private
	 */
	__init__() {
		if (!this.getLanguage()) {
			this.setLanguage();
		}

		this.cacheSet('translates', translates)

	}

	/**
	 *
	 * @param key
	 * @returns {*}
	 */
	get(key) {
		if (!key) {
			return "";
		}
		key = key.toUpperCase();
		return key ? this.cacheGet(this.cacheKey)[this.getLanguage()][key] : this.cacheGet(this.cacheKey);
	}

	/**
	 *
	 * @param key
	 */
	setLanguage(key) {
		this.cacheSet('language', ( key || window.navigator.language.split('_').pop() ).toUpperCase());
	}

	/**
	 *
	 * @returns {*}
	 */
	getLanguage() {
		const lang = this.cacheGet('language') || 'pl';
		return lang.toUpperCase();
	}

}

export default TranslatesService;



/** WEBPACK FOOTER **
 ** ./frontend/components/translates/translates.service.js
 **/